import LogRocket from "logrocket";

import { isCypress, isInternalBAIUser } from "js/config";

// Initialize LogRocket and identify user
export function identifyLogRocket(user, plan, subscriptionStatus) {
    if (isCypress) return;
    if (!isInternalBAIUser(user.email) && subscriptionStatus !== "trialing") return;

    LogRocket.init("1xdce1/beautifulai");
    LogRocket.identify(user.uid, {
        name: user.displayName || user.email,
        email: user.email,
        subscriptionType: plan
    });
}
